import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Container } from '@mui/material';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Blog from './pages/Blog';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import BusinessNewsPage from './pages/BusinessNewsPage';
import SingleNewsPage from './pages/SingleNewsPage';
import SingleArticlePage from './pages/SingleArticlePage';
import PoliticsNewsPage from './pages/PoliticsNewsPage';
import DetailPolticsNews from './pages/Allpolnews';
import SportsNewsPage from './pages/SportsNewsPage';
function App() {
  return (
    <Router>
      <Navbar />
      <Container sx={{ mt: 4 }} >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
                            <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsOfService />} />
                  <Route path="/cookies" element={<CookiePolicy />} />
                  <Route path="/business-news" element={<BusinessNewsPage />} />
          <Route path="/sports-news" element={<SportsNewsPage />} />
          <Route path="/article/:id" element={<SingleNewsPage />} />
          <Route path="/articles/:id" element={<SingleArticlePage />} />
          <Route path="/politics-news" element={<PoliticsNewsPage />} />
          <Route path="/allpolnews/:id" element={<DetailPolticsNews/>} />
        </Routes>
      </Container>
    </Router>
  );
}

export default App;
